import React from 'react';
import { gsap, Expo } from 'gsap';
import useLanguage from '../../../hooks/useLanguage';
import PropTypes from 'prop-types';

const ReactMarkdown = require("react-markdown");

const TextPage = ({ textData }) => {
  const langToggle = useLanguage;
  console.log(textData)
  const title = langToggle(textData.title_ua, textData.title_ru);
  let words = title.split('\n');

  const [tl] = React.useState(gsap.timeline({ paused: false }));

  let titleElement = React.useRef([]);
  let subTitleElement = React.useRef(null);

  React.useEffect(() => {
    tl.staggerTo(
      titleElement.current,
      1.5,
      { y: 0, opacity: 1, ease: Expo.easeOut, delay: 3.5 },
      0.2
    ).to(subTitleElement, 1.5, {
      y: 0,
      opacity: 1,
      ease: Expo.easeOut,
      delay: -1.25,
    });
  }, [tl, words]);

  return (
    <>
      <section id="top-section" className="text-page__main" data-scroll-section>
        <div className="text-page__main-center">
          <h1 className="text-page__main-title">
            {words.map((word, i) => {
              const speed = i === 0 ? '2' : i === 1 ? '1.5' : '1';

              if (word === ' ') {
                return (
                  <span
                    className="text-page__main-title-word__wrapper"
                    key={i}
                    id={i}
                    data-scroll=""
                    data-scroll-speed={speed}
                    data-scroll-delay="0.05"
                  >
                    <span
                      className="text-page__main-title-word"
                      ref={(e) => (titleElement.current[i] = e)}
                    >
                      &nbsp;
                    </span>
                  </span>
                );
              } else {
                return (
                  <span
                    className="text-page__main-title-word__wrapper"
                    key={i}
                    id={i}
                    data-scroll=""
                    data-scroll-speed={speed}
                    data-scroll-delay="0.05"
                  >
                    <span
                      className="text-page__main-title-word"
                      ref={(e) => (titleElement.current[i] = e)}
                    >
                      {word + (i !== words.length - 1 ? '\u00A0' : '')}
                    </span>
                  </span>
                );
              }
            })}
          </h1>
          <div className="text-page__main-subtitle__wrapper">
            <p
              className="text-page__main-subtitle"
              ref={(e) => (subTitleElement = e)}
            >
              {langToggle(textData.sub_title_ua, textData.sub_title_ru)}
            </p>
          </div>
        </div>
      </section>
      <section className="aricle-content__wrapper" data-scroll-section>
        <div className="article__markdown">
          <ReactMarkdown source={langToggle(textData.content_ua,textData.content_ru)} />  
        </div>
      </section>
    </>
  );
};

TextPage.propTypes = { textData: PropTypes.object };

export default TextPage;
